import i18n from "i18next";
import {initReactI18next} from "react-i18next";
// import LanguageDetector from 'i18next-browser-languagedetector';
// import translationsEN from './en.json'
// import translationsTR from './tr.json'
// import HttpApi from 'i18next-http-backend';

// const resources = {
//     en: {
//         translation: translationsEN
//     },
//     tr: {
//         translation: translationsTR
//     },
//
// };


// i18n
//     .use(HttpApi) // Load translation using http backend
//     .use(initReactI18next) // Passes i18n instance to react-i18next
//     .init({
//         fallbackLng: 'en',
//         lng: 'en', // Default language
//         backend: {
//             loadPath: 'https://vendor-provider.fra1.digitaloceanspaces.com/ebetlab/languages/website-2/{{lng}}.json', // Path to translation files
//         },
//         react: {
//             useSuspense: false, // Disable suspense mode for this setup
//         },
//     });


// i18n
//     .use(initReactI18next) // passes i18n down to react-i18next
//     .use(LanguageDetector)
//     .init({
//         resources,
//         fallbackLng: 'en', // default language
//         keySeparator: '.', // we do not use keys in form messages.welcome
//         interpolation: {
//             escapeValue: false // react already safes from xss
//         }
//     });


i18n
    .use(initReactI18next) // Connects React-i18next with the i18n instance
    .init({
        fallbackLng: 'en',
        lng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false, // React already does escaping
        },
    });


export default i18n;
